import React, { useId, useRef } from 'react';
import Container from './Container.js';
import ArrowLink from './ArrowLink.js';
const defaultImage = /*#__PURE__*/React.createElement("svg", {
  className: "ebds-feedback__image",
  viewBox: "0 0 234 148",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(43)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "22",
  y: "36",
  width: "103",
  height: "73",
  rx: "10",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m22 36h103l-51 38h-.5z",
  fill: "#0096e8",
  opacity: ".2"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.5 33.917v67.833c0 6.7833 5.55 12.333 12.333 12.333h86.333c6.7833 0 12.333-5.55 12.333-12.333v-67.833zm98.204 6.1667-42.704 30.14-42.704-30.14zm0.4625 67.833h-86.333c-3.3917 0-6.1667-2.775-6.1667-6.1667v-58.815l49.333 34.842 49.333-34.842v58.815c0 3.3917-2.775 6.1667-6.1667 6.1667z",
  fill: "#000"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#0096e8"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 31)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m15.048 4.3814 4.3398-4.3814 11.018 10.914-4.3406 4.3806z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15.045 81.824 11.112-11.006 4.3398 4.3814-11.112 11.006z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 39.191h15.347v6.1667h-15.347z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(203 31)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 75.196 4.3398-4.3806 11.11 11.008-4.3398 4.3806z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0.093271 10.914 11.017-10.914 4.3406 4.3814-11.017 10.914z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15.152 39.19h15.347v6.1667h-15.347z"
})))));
const Feedback = ({
  isStandout = false,
  withSeparator = true,
  headline,
  description,
  arrowlinkMailto,
  arrowlinkSubject,
  arrowlinkText,
  onClick = () => {},
  customImage = null
}) => {
  const componentId = useId();
  const componentRef = useRef();
  return /*#__PURE__*/React.createElement(Container, {
    standout: isStandout
  }, /*#__PURE__*/React.createElement("div", {
    id: `ebds-feedback-${componentId}`,
    ref: componentRef,
    className: "ebds-feedback"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ebds-feedback__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ebds-feedback__content__left-section"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "ebds-feedback__headline"
  }, headline), /*#__PURE__*/React.createElement("p", {
    className: "ebds-feedback__description"
  }, description), /*#__PURE__*/React.createElement(ArrowLink, {
    href: `mailto:${arrowlinkMailto}?subject=${arrowlinkSubject}`,
    onClick: onClick,
    className: "ebds-feedback__arrowlink",
    text: arrowlinkText
  })), /*#__PURE__*/React.createElement("div", {
    className: "ebds-feedback__content__right-section"
  }, customImage ? /*#__PURE__*/React.createElement("img", {
    src: customImage,
    alt: "feedback graphic",
    className: "ebds-feedback__image"
  }) : defaultImage)), withSeparator ? /*#__PURE__*/React.createElement("hr", null) : null));
};
export default Feedback;